export const SPA_UPDATE_EVENT_NAME = 'plugin_web_update_notice';

export function requestSpaUpdateCheck(): void {
  window.pluginWebUpdateNotice_?.checkUpdate();
}

export function registerVitePreloadErrorUpdateCheck(): () => void {
  const handlePreloadError = (): void => requestSpaUpdateCheck();

  window.addEventListener('vite:preloadError', handlePreloadError);
  return () => window.removeEventListener('vite:preloadError', handlePreloadError);
}
